import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "h-12 w-full min-w-0 rounded-2xl border-2 border-foreground/20 bg-[var(--surface-container-high)] px-4 py-3",
        "text-base transition-all duration-200 outline-none",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:bg-[var(--surface-container)] focus-visible:border-[var(--primary)] focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-2",
        "hover:bg-[var(--surface-container)] hover:border-foreground/30",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
